import { Component, Vue } from 'vue-property-decorator';
import { Menu } from '@/models';
import appStore from '@/store/app';
import NavBar from '@/components/NavBar';
import AsideMenu from '@/components/AsideMenu';
import FooterBar from '@/components/FooterBar';

@Component({
  components: {
    FooterBar,
    AsideMenu,
    NavBar,
  },
})
export default class App extends Vue {

  get menu(): Menu[] {
    return appStore.menu;
  }

  get isLoading(): boolean {
    return appStore.isLoading;
  }

}
